import { GET_RECOMMENDATIONS, RecommendationsState, RESET_STATE } from '@pbl/pbl-react-core/lib/models/recommendations/types';
import { FAILURE, REQUEST, SUCCESS } from 'redux/action-type.util';

const INITIAL_STATE = {
  loading: false,
  recommendations: []
};

export default (state: RecommendationsState = INITIAL_STATE, action): RecommendationsState => {
  switch (action.type) {
    case REQUEST(GET_RECOMMENDATIONS):
      return {
        ...state,
        loading: true
      };
    case FAILURE(GET_RECOMMENDATIONS):
      return {
        ...state,
        loading: false
      };
    case SUCCESS(GET_RECOMMENDATIONS):
      return {
        ...state,
        loading: false,
        recommendations: action.payload
      };
    case RESET_STATE:
      return {
        ...INITIAL_STATE
      };
    default:
      return state;
  }
};
